import { Injectable, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ConfigurationHttpService } from "../services/configuration.service";

@Injectable()

/**
 * Добавляет BasePath к запросам
 */
export class BaseRouteInterceptor implements HttpInterceptor {

    constructor(
        private config: ConfigurationHttpService
    ) {
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let request = req;
        const applicationUrl = window.location.origin;
        const applicationWithBaseRouteUrl = this.config.apiUrl;

        if (req.url.includes(applicationUrl, 0) && !req.url.includes(applicationWithBaseRouteUrl, 0)) {
            const newUrl = req.url.replace(applicationUrl, applicationWithBaseRouteUrl);
            request = req.clone({ url: newUrl });
        }
        return next.handle(request).pipe(
            tap(
                (err) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status == 403)
                            this.notifyForRedirectToLogin();
                    }
                }
            )
        );
    }

    private notifyForRedirectToLogin(): void {
    }
}